import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type CrmLead = {
  id: string
  apollo_id: string | null
  first_name: string | null
  last_name: string | null
  full_name: string | null
  email: string | null
  email_status: 'verified' | 'guessed' | 'unknown' | null
  title: string | null
  company: string | null
  linkedin: string | null
  city: string | null
  country: string | null
  source: 'manual' | 'apollo' | 'inbound' | 'website'
  pipeline_stage: 'new' | 'contacted' | 'replied' | 'meeting' | 'proposal' | 'negotiation' | 'won' | 'lost'
  notes: string | null
  assigned_to: 'samantha' | 'amy' | 'manual' | null
  created_at: string
  updated_at: string
  last_contacted_at: string | null
}

export type CrmOutreach = {
  id: string
  lead_id: string
  type: 'email' | 'linkedin' | 'call' | 'meeting'
  direction: 'outbound' | 'inbound'
  subject: string | null
  body: string | null
  status: 'sent' | 'delivered' | 'opened' | 'replied' | 'bounced'
  sent_by: 'samantha' | 'amy' | 'manual'
  created_at: string
}

export type CrmPipelineStatsRow = {
  pipeline_stage: string
  count: number
}
